import { parse } from "util/parsers";
import type {
    OnboardingApplicationLogsPaginator,
    OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges
} from "../types";

export const parseChanges = ({ data, ...paginator }: OnboardingApplicationLogsPaginator<
    Record<
        string,
        OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges[]
    >
>) => ({
    ...paginator,
    data: Object.entries(data)
        .reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value.map(({ changes, previousChanges, ...restEntry }) => ({
                ...restEntry,
                changes: parse(String(changes)),
                previousChanges: parse(String(previousChanges))
            }))
        }), {})
});
